import { MarketStatus } from "app/utils/const";
//
export class HasClosedMarketHelper {
  static hasClosedMarket: any = (marketPeriod: Record<string, any>) => {
    let found = false;
    marketPeriod.marketTypes.forEach(mt => {
      mt.markets.forEach(m => {
        if (
          m.status === MarketStatus.CLOSED ||
          m.status === MarketStatus.GRADED
        ) {
          found = true;
        }
      });
    });
    return found;
  };
}
